import {isEmpty} from "underscore";

import {
  IssueOverrideFields,
  OverrideFieldName,
  PerIssuesetOverrideTagValues,
} from "common/types/issue";
import {IssueOverrideTagId} from "common/types/issue_override_tag";
import {IssuesetId} from "common/types/issueset";

const getOverrideFields = (
  existingOverrides: PerIssuesetOverrideTagValues,
  issuesetId: IssuesetId,
  tagId: IssueOverrideTagId,
): IssueOverrideFields =>
  existingOverrides?.[issuesetId]?.[tagId]?.fields || {};

export const setOverrideFieldValue = (
  existingOverrides: PerIssuesetOverrideTagValues,
  issuesetId: IssuesetId,
  tagId: IssueOverrideTagId,
  field: OverrideFieldName,
  value: string,
): PerIssuesetOverrideTagValues => {
  const updatedFields: IssueOverrideFields = {
    ...getOverrideFields(existingOverrides, issuesetId, tagId),
    [field]: value,
  };

  return {
    ...existingOverrides,
    [issuesetId]: {
      ...existingOverrides[issuesetId],
      [tagId]: {
        fields: updatedFields,
      },
    },
  };
};

export const removeFieldOverride = (
  existingOverrides: PerIssuesetOverrideTagValues,
  issuesetId: IssuesetId,
  tagId: IssueOverrideTagId,
  field: OverrideFieldName,
): PerIssuesetOverrideTagValues => {
  const fields = {...getOverrideFields(existingOverrides, issuesetId, tagId)};

  delete fields[field];

  const newOverrides = {...existingOverrides};

  if (isEmpty(fields)) {
    delete newOverrides[issuesetId][tagId];

    if (isEmpty(newOverrides[issuesetId])) {
      delete newOverrides[issuesetId];
    }
  } else {
    newOverrides[issuesetId][tagId] = {fields};
  }

  return newOverrides;
};
